export default __webpack_public_path__ + "static/media/node.52cbf9a8.svg";